import { useStore } from 'vuex';
import { onMounted } from 'vue';
import { $gfLeftSideBar } from '@/app/index';
import { TCategorySidebar } from '../types';
import { SNIPPET_REMOVED } from '../constants';
type TSnippetCategoryProps = {
  item: TCategorySidebar;
};

const $vectors = {
  toggle: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.9219 9.94824L12.2319 14.6378V14.6378C12.104 14.7659 11.8965 14.766 11.7685 14.6381C11.7683 14.638 11.7682 14.6379 11.7681 14.6378L7.07812 9.94824" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  info: `<svg width="15" height="15" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.42578 5.25V4.07422H7.57422V5.25H6.42578ZM3.69141 10.3086C4.62109 11.2201 5.72396 11.6758 7 11.6758C8.27604 11.6758 9.36979 11.2201 10.2812 10.3086C11.2109 9.37891 11.6758 8.27604 11.6758 7C11.6758 5.72396 11.2109 4.63021 10.2812 3.71875C9.36979 2.78906 8.27604 2.32422 7 2.32422C5.72396 2.32422 4.62109 2.78906 3.69141 3.71875C2.77995 4.63021 2.32422 5.72396 2.32422 7C2.32422 8.27604 2.77995 9.37891 3.69141 10.3086ZM2.87109 2.89844C4.01953 1.75 5.39583 1.17578 7 1.17578C8.60417 1.17578 9.97135 1.75 11.1016 2.89844C12.25 4.02865 12.8242 5.39583 12.8242 7C12.8242 8.60417 12.25 9.98047 11.1016 11.1289C9.97135 12.2591 8.60417 12.8242 7 12.8242C5.39583 12.8242 4.01953 12.2591 2.87109 11.1289C1.74089 9.98047 1.17578 8.60417 1.17578 7C1.17578 5.39583 1.74089 4.02865 2.87109 2.89844ZM6.42578 9.92578V6.42578H7.57422V9.92578H6.42578Z" fill="currentColor"/></svg>`,
  add: `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="15" cy="15" r="14.5" stroke="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M14.5 23V7H15.5V23H14.5Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23 15.5L7 15.5L7 14.5L23 14.5L23 15.5Z" fill="currentColor"/></svg>`,
};

function _generateTriggerButton() {
  const svg = $vectors['toggle'];
  return `<span class="gf-sperator-element_toggler">${svg}</span>`;
}

export const useSnippetCategory = (props: TSnippetCategoryProps) => {
  const { item } = props;
  const store = useStore();
  const getClassesWrapper = () => {
    return `gf-sperator-element xdsoft_noselect gf-${item.key}`;
  };
  const pageType = computed(() => store.getters['app/pageType']);
  const handleHeaderToggle = () => {
    const element = document.getElementById(`toggle-header-${item.id}`);
    if (element) {
      $(element).append(_generateTriggerButton());
      $(element)
        .off('click.toggle')
        .on('click.toggle', function () {
          const $item = $(element);
          const $child = $item.find('.gf-sperator-element_toggler');

          if ($child.length > 0) {
            $child.toggleClass('closed');
          } else {
            $item.append(_generateTriggerButton());
          }

          $item.next().slideToggle('fast');
        });
    }
  };

  const newSnippets = computed(() => {
    return store.state.sidebar.newSnippets[item.name] || [];
  });

  const snippetDeleted = computed(() => {
    return store.state.sidebar.snippetDeleted;
  });

  const snippets = computed(() => {
    return (item.snippets || [])
      .filter((snippet) => {
        return !newSnippets.value.find((it) => it.id == snippet.id);
      })
      .concat(newSnippets.value)
      .filter((item) => !snippetDeleted.value[item.id] && !SNIPPET_REMOVED.includes(item.key));
  });

  onMounted(() => {
    if (item.key === 'other_elements') {
      $gfLeftSideBar().data('gfleftsidebar').addMoreButton(pageType.value);
      $gfLeftSideBar().data('gfleftsidebar').addEventForAddMoreSnippet();
    }
    handleHeaderToggle();
  });

  return { item, getClassesWrapper, handleHeaderToggle, snippets };
};
